import * as type from './types';
import { createReducer } from "../../util/index";

const initialState =
{
    // data: [],
};

const gameVendorFavReducer = createReducer(initialState) ({
    [type.GAME_VENDOR_FAV]: (state, action) => ({
        ...state,
        game_vendor_fav: action.payload
    }),
    [type.UPDATE_GAME_VENDOR_FAV]: (state, action) => ({
        ...state,
        update_game_vendor_fav: action.payload
    })
});

export default gameVendorFavReducer;